import React, { useContext } from "react";
import { Context as GamesContext } from "../context/GamesContext";
import { Nav, NavItem, List, ListItem } from "./Nav";
import { FormInput } from "./FormInput";

const CreateGameContext = () => {
  const { state, formNavigate, handleInputChange, setProduct } =
    useContext(GamesContext);
  const {
    products,
    formStep,
    selected_product,
    selected_product_type,
    game_group_name,
    game_group_nameValidationMessage,
    game_group_nameValidated,
    game_group_players,
    game_group_playersValidated,
    game_group_playersValidationMessage,
    world_count,
    tags_string,
    game_group_invite_string,
  } = state;
  const product_types = [
    ...new Set(products.map((product) => product.product_type)),
  ];

  const setProductAndNavigate = (product) => {
    setProduct({ product });
    const diff = 1;
    formNavigate({ diff });
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    handleInputChange({ name, value, selected_product });
  };

  switch (formStep) {
    case 1:
      return (
        <div className="divide-y divide-coolGray-200">
          <Nav>
            {product_types.map((item) => (
              <NavItem
                key={item}
                isActive={item === selected_product_type ? true : false}
              >
                {item}
              </NavItem>
            ))}
          </Nav>
          <List>
            {products
              // .filter(
              //   (product) => product.product_type === selected_product_type
              // )
              .map((product) => (
                <ListItem
                  key={product.id}
                  product={product}
                  setProductAndNavigate={() => setProductAndNavigate(product)}
                />
              ))}
          </List>
        </div>
      );
    case 2:
      return (
        <div className="mb-5">
          <FormInput
            labelText="Give your game a name."
            type="text"
            placeHolderText="SocSci220"
            value={game_group_name}
            name="game_group_name"
            validationMessage={game_group_nameValidationMessage}
            validated={game_group_nameValidated}
            onChange={(e) => handleChange(e)}
          />
          <FormInput
            labelText="Roughly how many players will be playing?"
            type="number"
            placeHolderText="1"
            value={game_group_players}
            name="game_group_players"
            validationMessage={game_group_playersValidationMessage}
            validated={game_group_playersValidated}
            onChange={(e) => handleChange(e)}
          />
          <div className="my-2 flex flex-row items-center">
            <div className="text-2xl font-semibold text-coolGray-600 uppercase">
              Number of worlds needed:
            </div>
            <div className="rounded-full shadow bg-coolGray-200 h-9 w-9 flex items-center justify-center ml-5 font-bold text-emerald-400 text-2xl">
              {world_count}
            </div>
          </div>
          <div>
            <FormInput
              labelText="Add an optional tag or group of tags to organize your game."
              type="text"
              placeHolderText="SocSci220, Fall2020, UVASocSci"
              value={tags_string}
              name="tags_string"
              validationMessage={true}
              validated={true}
              onChange={(e) => handleChange(e)}
            />
          </div>
        </div>
      );
    case 3:
      return (
        <div>
          <FormInput
            labelText="Enter participant emails, seperated by a comma."
            type="text"
            placeHolderText="sally.ride@gmail.com, johnDoe123@uva.edu"
            value={game_group_invite_string}
            name="game_group_invite_string"
            validationMessage={true}
            validated={true}
            onChange={(e) => handleChange(e)}
          />
        </div>
      );
    default:
      break;
  }
};

export default CreateGameContext;
